import { NavLink } from "react-router-dom";
import { Store, Briefcase, Image } from "lucide-react";

const TABS = [
  { to: "/marketplace", label: "Asset Store", icon: Store, testid: "market-tab-assets" },
  { to: "/jobs", label: "Contracts", icon: Briefcase, testid: "market-tab-contracts" },
  { to: "/gallery", label: "Workshop", icon: Image, testid: "market-tab-workshop" },
];

export default function MarketTabs() {
  return (
    <div data-testid="market-tabs" className="border-b border-white/10 bg-[#070707]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={t.testid}
            className={({ isActive }) =>
              `font-mono text-[10px] tracking-[0.25em] uppercase px-5 py-3.5 border-b-2 transition-colors duration-200 flex items-center gap-2 whitespace-nowrap ${
                isActive ? "border-nc-orange text-zinc-50 bg-zinc-900/60" : "border-transparent text-zinc-500 hover:text-zinc-200"
              }`
            }
          >
            <t.icon className="w-3.5 h-3.5" /> {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
